// extracted by mini-css-extract-plugin
export default {"login-form":"Login_login-form__ZiW74","error":"Login_error__G0Zsn"};